module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAARCAMAAADwppwCAAAAAXNSR0IB2cksfwAAAEJQTFRFAAAA/////////////////////////vLy97Oz8oCA72dn////+szM7U1N6jQ08G1t8Gxs6jY2//3972Zm72lp8GlpvE8mfwAAABZ0Uk5TABDv/yCAMP////9A//////////////feOWQAAACGSURBVHicjZDhEgIhCIRVUqFT6rLe/1VTDmb0qpn2j85+sArOHfIBROHiVkVQxdVPwUBIZqmRka6E2Xhy23EplYdqUbApKGwqC8iVb2LfueYZYPeAeX/0E2dAoxrEZ5pBG84OktbOHb0ePjpQ8+H8Rv/VU3JeXP+b4/fksqtGaKvqwMev8m/nkwrSpnfNkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-camera.png
// module id = 811
// module chunks = 1